export default __webpack_public_path__ + "static/media/meta.b6d231a8.svg";